import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[100svh] flex items-center overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <video
          src="https://public.readdy.ai/ai/video_res/019fb24d-f0da-70f0-8544-63f7006e7161.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/30 via-transparent to-foreground-950/20"></div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-background-50/6"></div>

      <div className="relative z-10 w-full px-6 md:px-10 py-24 md:py-32">
        <div className="max-w-4xl mx-auto text-center">
          <h1
            className="font-heading text-[3.5rem] md:text-[5rem] lg:text-[6rem] font-bold text-background-50 leading-[1.06] mb-7 tracking-tight"
            style={{ textShadow: '0 2px 12px rgba(0,0,0,0.5), 0 1px 4px rgba(0,0,0,0.35)' }}
          >
            {siteConfig.brandName}
          </h1>

          <p
            className="text-base md:text-lg text-background-50/55 leading-relaxed max-w-lg mx-auto mb-11 font-light tracking-wide"
            style={{ textShadow: '0 1px 6px rgba(0,0,0,0.45), 0 1px 3px rgba(0,0,0,0.3)' }}
          >
            呈現樂律目前出版的書籍與品牌內容，提供讀者瀏覽正式書目、查找出版資訊及聯絡合作的入口。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap px-7 py-3 rounded-full text-[15px] font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer tracking-wide"
            >
              認識樂律
              <i className="ri-arrow-right-line ml-2 text-[13px]"></i>
            </Link>
            <a
              href={siteConfig.catalogUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap px-7 py-3 rounded-full text-[15px] font-medium bg-gradient-to-r from-accent-500 to-primary-500 text-white hover:from-accent-600 hover:to-primary-600 transition-all cursor-pointer tracking-wide"
            >
              前往書籍資料庫
              <i className="ri-external-link-line ml-2 text-[13px]"></i>
            </a>
            <Link
              to="/faq"
              className="whitespace-nowrap px-7 py-3 rounded-full text-[15px] font-medium bg-secondary-400 text-white hover:bg-secondary-500 transition-colors cursor-pointer tracking-wide"
            >
              常見問題
              <i className="ri-arrow-right-line ml-2 text-[13px]"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50/20 to-transparent"></div>
    </section>
  );
}